import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from '@core/services/language.service';
import { environment } from '@env/environment';

/**
 * 🌐 Language Interceptor — báo Backend ngôn ngữ người dùng đang chọn qua header chuẩn `Accept-Language`.
 *
 * - Giá trị lấy từ `LanguageService.currentLang()` (`vi` | `en`), đọc tại thời điểm gửi request ⇒ đổi ngôn
 *   ngữ là request kế tiếp mang giá trị mới, không cần reload.
 * - **Ghi đè** header trình duyệt tự gửi: trình duyệt dùng ngôn ngữ của hệ điều hành, không phải ngôn ngữ
 *   chọn trong app.
 * - Chỉ gắn cho API của Backend; bỏ qua file tĩnh (`./i18n/*.json`) và request tới bên thứ ba.
 * - `Accept-Language` là header CORS-safelisted ⇒ Backend không cần khai báo thêm CORS.
 */
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const isBackendApi = req.url.startsWith(environment.apiUrl) || req.url.startsWith('/api');
  if (!isBackendApi) {
    return next(req);
  }

  const lang = inject(LanguageService).currentLang();
  return next(req.clone({ setHeaders: { 'Accept-Language': lang } }));
};
